import { TPPClaimsState } from "@/models/store/TPPClaimsState";

export const filterParamsMutations = {
  setNameParam: (state: TPPClaimsState, name: string) => {
    state.filterParams.name = name;
  },
  setClaimNumberParam: (state: TPPClaimsState, claimNumber: string) => {
    state.filterParams.claim_number = claimNumber;
  },
  setClaimStatusParam: (state: TPPClaimsState, claimStatus: string[]) => {
    state.filterParams.status = claimStatus;
  },
  setDateParam: (state: TPPClaimsState, date: string) => {
    state.filterParams.date = date;
  },
  setLocationCodeParam: (state: TPPClaimsState, locationCode: string[]) => {
    state.filterParams.location_code = locationCode;
  },
  setLossTypeParam: (state: TPPClaimsState, lossType: string[]) => {
    state.filterParams.loss_type = lossType;
  },
  resetFilterParams: (state: TPPClaimsState) => {
    state.filterParams.name = "";
    state.filterParams.claim_number = "";
    state.filterParams.date = "";
    state.filterParams.location_code = [];
    state.filterParams.loss_type = [];
    state.filterParams.status = [];
  }
};
